import { EntityReference } from '../../core/api/api.entities';
import { FormOptions } from './base.form-options';

export class QuickActionFormOptions extends FormOptions {
  locations: EntityReference[] = [];
  stores: EntityReference[] = [];
}
